import { MutableRefObject, RefObject, useCallback, useState } from 'react';

import Velocity from 'velocity-animate';

type Params = {
    calcTrackOffset: (newOffset: number) => number;
    bannerSliderTrack: RefObject<HTMLDivElement> | null;
    instantJumpToSlide: (jumpPos: number) => void;
    offsetValue: MutableRefObject<number>;
    lock: MutableRefObject<boolean>;
    childrenCount: number;
    animationSlideTime: number;
};

export const useAnimateSlideJump = ({
    calcTrackOffset,
    bannerSliderTrack,
    instantJumpToSlide,
    offsetValue,
    lock,
    childrenCount,
    animationSlideTime
}: Params) => {
    const [dotPosition, setDotPosition] = useState(0);

    const animateSlideJump = useCallback(
        (middlePos, endPos, jumpPos, animationTime1, animationTime2) => {
            Velocity(bannerSliderTrack?.current, { left: calcTrackOffset(middlePos) }, { duration: animationTime1 })
                .then(() => {
                    instantJumpToSlide(jumpPos);
                })
                .then(() => {
                    if (bannerSliderTrack?.current) {
                        return Velocity(
                            bannerSliderTrack.current,
                            { left: calcTrackOffset(endPos) },
                            {
                                queue: false,
                                duration: animationTime2
                            }
                        );
                    }
                })
                .then(() => {
                    offsetValue.current = endPos;
                    lock.current = false;
                    const dotPosition = offsetValue.current % childrenCount;
                    setDotPosition(dotPosition);
                });
        },
        [bannerSliderTrack, calcTrackOffset, childrenCount, instantJumpToSlide, lock, offsetValue]
    );

    const animateSlide = useCallback(() => {
        if (bannerSliderTrack?.current) {
            Velocity(
                bannerSliderTrack.current,
                { left: calcTrackOffset(offsetValue.current) },
                { duration: animationSlideTime }
            ).then(() => {
                lock.current = false;
                const dotPosition = offsetValue.current % childrenCount;
                setDotPosition(dotPosition);
            });
        }
    }, [animationSlideTime, bannerSliderTrack, calcTrackOffset, childrenCount, lock, offsetValue]);

    return { animateSlideJump, dotPosition, animateSlide };
};
